var _path, _path2, _path3, _mask, _path4, _mask2, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1227,
    height: 945,
    viewBox: "0 0 1227 945",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3H989.5",
    stroke: "#E5E5E5",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.5 463H989.5",
    stroke: "#E5E5E5",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.5 924L1227 924",
    stroke: "#E5E5E5",
    strokeWidth: 6
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_4785_1593",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M989 1H991.5C1119.91 1 1224 105.094 1224 233.5C1224 361.906 1119.91 466 991.5 466H989V1Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M989 -5H991.5C1123.22 -5 1230 101.78 1230 233.5H1218C1218 108.408 1116.59 7 991.5 7H989V-5ZM1230 233.5C1230 365.22 1123.22 472 991.5 472H989V460H991.5C1116.59 460 1218 358.592 1218 233.5H1230ZM1218 233.5M989 466V1V466M991.5 -5C1123.22 -5 1230 101.78 1230 233.5C1230 365.22 1123.22 472 991.5 472V460C1116.59 460 1218 358.592 1218 233.5C1218 108.408 1116.59 7 991.5 7V-5Z",
    fill: "#E5E5E5",
    mask: "url(#path-4-inside-1_4785_1593)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_4785_1593",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 462H232.5C104.094 462 0 566.094 0 694.5C0 822.906 104.094 927 232.5 927H235V462Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235 456H232.5C100.78 456 -6 562.78 -6 694.5H6C6 569.408 107.408 468 232.5 468H235V456ZM-6 694.5C-6 826.22 100.78 933 232.5 933H235V921H232.5C107.408 921 6 819.592 6 694.5H-6ZM6 694.5M235 927V462V927M232.5 456C100.78 456 -6 562.78 -6 694.5C-6 826.22 100.78 933 232.5 933V921C107.408 921 6 819.592 6 694.5C6 569.408 107.408 468 232.5 468V456Z",
    fill: "#E5E5E5",
    mask: "url(#path-6-inside-2_4785_1593)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.76 460.505C1000.66 461.742 1000.77 463.639 1002 464.74L1022.17 482.697C1023.41 483.798 1025.3 483.689 1026.4 482.451C1027.51 481.214 1027.4 479.318 1026.16 478.216L1008.24 462.255L1024.2 444.331C1025.3 443.094 1025.19 441.198 1023.95 440.096C1022.71 438.994 1020.82 439.104 1019.72 440.341L1001.76 460.505ZM1214.5 288L1211.57 287.335C1196.78 352.448 1131.61 452.104 1003.83 459.505L1004 462.5L1004.17 465.495C1135.39 457.896 1202.22 355.552 1217.43 288.665L1214.5 288Z",
    fill: "#43B89B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223.74 922.004C224.842 923.241 224.733 925.137 223.496 926.24L203.338 944.202C202.101 945.305 200.205 945.196 199.102 943.959C198 942.722 198.109 940.825 199.346 939.723L217.264 923.756L201.298 905.838C200.195 904.601 200.304 902.705 201.541 901.602C202.778 900.5 204.675 900.609 205.777 901.846L223.74 922.004ZM9.5 749.5L12.4246 748.832C27.2174 813.55 93.8705 913.645 221.672 921.005L221.5 924L221.328 926.995C90.1295 919.44 21.7826 816.7 6.57542 750.168L9.5 749.5Z",
    fill: "#71AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadMap);
export default __webpack_public_path__ + "static/media/road-map.ae01abcc6d428b0e9933fc358d3fa03f.svg";
export { ForwardRef as ReactComponent };